import { AxiosError } from 'axios';
import { GET_SINGPASS_CONSENT_URL } from '../../constants/apiUrls';
import { GET_SINGPASS_CONSENT_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Response Model
// =============================================================================
interface GetSingPassConsentResponse {
  url: string;
  csrf: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: GetSingPassConsentResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetSingPassConsent = ({ onSuccess, onError }: Input) => {
  const getSingPassConsent = async () => {
    const res = await axiosClient.get<GetSingPassConsentResponse>(GET_SINGPASS_CONSENT_URL);

    return res.data;
  };

  return useCustomQuery(
    GET_SINGPASS_CONSENT_QUERY_KEY,
    getSingPassConsent,
    {
      enabled: false,
      onSuccess,
      onError,
    },
    false
  );
};
